angular.module('MW.Framework.NewsService', ['MW.Framework.CoreCompanyService', 'MW.Framework.DateRangeHelper', 'Configuration', 'MW.Framework.InformationTypeService', 'MW.Framework.FeatureToggleService'])
    .service('NewsService', ['CoreCompanyService', '$q', '$http', 'DateRangeHelper', 'MASF_SERVICES_URL', 'MASF_TAG_SERVICES_URL', 'InformationTypeService', 'FeatureToggleService',
        function (CoreCompanyService, $q, $http, DateRangeHelper, MASF_SERVICES_URL, MASF_TAG_SERVICES_URL, InformationTypeService, FeatureToggleService) {
            'use strict';

            /**
             * Filters the given list of searches down to the list that matches filter.  The only supported
             * filter right now is informationTypes.  If provided, all searches must include at least one
             * of the information types in filter.informationTypes
             *
             * @param searches
             * @param filter
             */
            function filterSearches(searches, filter) {
                var search,
                    filteredSearches = [],
                    normalizedInformationType;

                // default to just news searches
                filter = filter || {};
                filter.informationTypes = filter.informationTypes || [InformationTypeService.NEWS_TYPE];

                for (var i in searches) {
                    search = searches[i];

                    normalizedInformationType = InformationTypeService.getNormalizedInformationType(search.searchQuery.informationTypes);
                    if (filter.informationTypes.indexOf(normalizedInformationType) != -1) {
                        filteredSearches.push(search);
                    }
                }
                return filteredSearches;
            }

            return {
                getCompanySearches: function (options) {
                    options = options || {};
                    var companyId;

                    return $q.when(CoreCompanyService.getCurrent(true).then(function (data) {
                        companyId = data._id;

                        return $http.get(
                            MASF_SERVICES_URL + '/list/' + companyId,
                            {cache: false, headers: {}})
                            .then(function handleSearchesResponse(response) {
                                return FeatureToggleService.isOn('informationTypeToggle').then(function (informationTypeToggleState) {
                                    if (!response || !response.data) {
                                        return response;
                                    } else {
                                        if (!informationTypeToggleState || options.filter) {
                                            response.data = filterSearches(response.data, options.filter);
                                        }
                                        return response;
                                    }
                                });
                            });
                    }));
                },

                getSavedSearchById: function (savedSearchId) {
                    return $http.get(MASF_SERVICES_URL + '/' + savedSearchId, {
                        cache: false,
                        headers: {}
                    });
                },

                getCompanyTags: function () {
                    return $http.get(MASF_TAG_SERVICES_URL + '/', {
                        cache: false,
                        headers: {}
                    });
                }
            };
        }
    ]);